import { Box, Text } from '@chakra-ui/react';
import { JsonLd } from '@/components/seo/JsonLd';
import { homeDoors, profile as fallbackProfile } from '@/data/profile';
import { AppLink } from '@/lib/router';
import { useGetProfileQuery } from '@/store/profileApi';

export function HomePage() {
  const { data } = useGetProfileQuery();
  const site = data ?? fallbackProfile;

  return (
    <>
      <JsonLd />
      <Box as="main" id="main">
        <Box
          id="top"
          as="section"
          px={{ base: '5', md: '8' }}
          pt={{ base: '14', md: '20' }}
          pb={{ base: '16', md: '24' }}
        >
          <Box maxW="6xl" mx="auto">
            <div className="hero-stage">
              <h1 className="wordmark">{site.shortName}</h1>
            </div>
            <Box className="glass hero-note">
              <Text fontSize={{ base: 'lg', md: 'xl' }} lineHeight="1.6" color="fg">
                {site.abstract}
              </Text>
              <p className="soft hero-note__floor">{site.floor}</p>
            </Box>
            <nav className="doors" aria-label="Sections">
              {homeDoors(site.nav).map((door, index) => (
                <AppLink
                  key={`${door.label}-${door.href}`}
                  href={door.href}
                  className={door.featured ? 'door door--featured' : 'door'}
                >
                  <span className="door__idx">{String(index + 1).padStart(2, '0')}</span>
                  <span className="door__label">{door.label}</span>
                </AppLink>
              ))}
            </nav>
          </Box>
        </Box>
      </Box>
    </>
  );
}
